/* ------------------------------------------------------------------
// NOTE: 現在のページのパスに一致するメニュー項目にclass="active" を付与し、
// どの項目がアクティブかを示す。
--------------------------------------------------------------------- */
function setActiveMenuItem() {
  $(".jsSetActive")
    .filter((_, el) => $(el).data("path") === location.pathname)
    .addClass("active");
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default setActiveMenuItem;